         <!-- Content Wrapper Start -->
         <div class="fm-content-wrapper">
            <div class="container-fluid">
               <div class="row">
                  <div class="col-12">
                     <div class="row align-items-center">
                        <div class="col-sm">
                           <!-- Page Title -->
                           <div class="fm-page-title">
                              <h2 class="fm-head-24 fm-title mb-2">Storybook Generator</h2>
                              <p class="mb-0">Create beautiful books from your life stories to share and treasure</p>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <!-- Create Story Book Section Start -->
               <div class="row">
                  <div class="col-lg-8 col-xxl-8">
                     <div class="row">
                        <div class="col-xl-12">
                           <div class="fm-white-column fm-match-height">
                              <div class="accordion fm-accordion fm-accordion-st2">
                                 <div class="accordion-item fm-accordion-item mt-0">
                                    <span class="accordion-header fm-accordion-header">
                                    <button class="accordion-button fm-accordion-button">
                                    Storybook Details
                                    </button>
                                    </span>
                                    <div id="fmStoryDetails">
                                       <div class="accordion-body fm-accordion-body pt-3">
                                          <div class="row g-4">
                                             <div class="col-md-6">
                                                <div class="row">
                                                   <div class="col-12">
                                                      <div class="form-group">
                                                         <label class="form-label fm-label">Storybook Title <span class="fm-required">*</span></label>
                                                         <input type="text" class="form-control fm-form-control" placeholder="Enter storybook title" />
                                                      </div>
                                                   </div>
                                                   <div class="col-12 mt-3">
                                                      <div class="form-group">
                                                         <label class="form-label fm-label">Description <span class="fm-required">*</span></label>
                                                         <textarea class="form-control fm-form-control" placeholder="Enter storybook description"></textarea>
                                                      </div>
                                                   </div>
                                                </div>
                                             </div>
                                             <div class="col-md-6">
                                                <div class="form-group fm-file-upload-group">
                                                   <label class="form-label fm-label">Cover Page Image <span class="fm-required">*</span></label>
                                                   <div class="fm-thumbnail-upload-inline" id="fmAudioThumbnailUpload">
                                                      <label for="fmAudioThumbnailInput" class="fm-thumbnail-upload-btn mb-0">
                                                      <img src="images/icons/fm-upload-icon.svg" class="fm-svg" alt="Upload Thumbnail" />
                                                      <span class="fm-upload-helper-text">Drop your photo here, or <span class="fm-browse-text">Browse</span></span>
                                                      </label>
                                                      <input type="file" id="fmAudioThumbnailInput" class="fm-thumbnail-file-input" accept="image/*" />
                                                      <div class="fm-thumbnail-preview d-none" id="fmAudioThumbnailPreview">
                                                         <img src="images/people-1.png" class="fm-thumbnail-preview-image" alt="Thumbnail Preview" />
                                                         <div class="fm-thumbnail-preview-info">
                                                            <span class="fm-thumbnail-preview-name">preview.jpg</span>
                                                            <span class="fm-thumbnail-preview-size">0 KB</span>
                                                         </div>
                                                         <button type="button" class="fm-x-btn fm-thumbnail-remove-btn" aria-label="Remove thumbnail">
                                                         <img src="images/icons/fm-x.svg" alt="Remove" />
                                                         </button>
                                                      </div>
                                                   </div>
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div class="row">
                        <div class="col-12 mt-2 mt-xl-3">
                           <div class="fm-white-column">
                              <div class="row gy-3 gx-3 gx-xl-4">
                                 <div class="col-12 col-sm">
                                    <h2 class="fm-head-24 fm-title fm-title-dark mb-2">Select Stories</h2>
                                    <p class="mb-0">3 of 4 stories selected</p>
                                 </div>
                                 <div class="col-sm-auto">
                                    <div class="row gy-3 gx-3 gx-xl-4">
                                       <div class="col">
                                          <select class="form-select fm-form-select">
                                             <option selected>Filters</option>
                                             <option value="1">My Stories</option>
                                             <option value="2">Family Stories</option>
                                             <option value="3">Shared Stories</option>
                                          </select>
                                       </div>
                                       <div class="col-auto">
                                          <div class="fm-filter-btn-grp">
                                             <button type="button" class="fm-filter-cl-btn fm-filter-grid-btn fm-fb-active">
                                             <img src="images/icons/fm-column.svg" class="fm-svg" alt="Filter Column Icon" />
                                             </button>
                                             <button type="button" class="fm-filter-cl-btn fm-filter-list-btn">
                                             <img src="images/icons/fm-list.svg" class="fm-svg" alt="Filter List Icon" />
                                             </button>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                              <div class="row">
                                 <div class="col-md-6 mt-4">
                                    <div class="fm-stories-blog fm-match-height fm-story-select-card active" tabindex="0" role="button" aria-label="Select story: My First Day of School">
                                       <div class="fm-stories-cover">
                                          <img class="fm-image" src="images/stories/stories-post-1.png" alt="Review Cover Image">
                                          <span class="fm-tag">2:22</span>
                                          <button class="fm-stories-pp"><img src="images/icons/fm-play.svg" alt="Play Icon" class="fm-svg" /></button>
                                       </div>
                                       <div class="fm-stories-content">
                                          <span class="fm-check-icon">
                                             <img  src="images/icons/fm-check.svg" class="fm-svg" alt="Selected" />
                                          </span>
                                          <div class="fm-st-promt-tag">
                                             <span class="fm-st-ti">Childhood</span>
                                             <span class="fm-st-ti fm-light-green"><img src="images/icons/fm-video-icon.svg" class="fm-svg" alt="Video Icon"> Video</span>
                                          </div>
                                          <h4 class="fm-head-20 fm-head-sty2"><a href="stories-details.html">My First Day of School</a></h4>
                                          <div class="fm-user-profile">
                                             <div class="fm-userprofile">
                                                <div class="fm-left">
                                                   <div class="fm-userprofile-image">
                                                      <img class="fm-profile" src="images/stories/fm-st-user-01.png" alt="Image">
                                                   </div>
                                                   <span class="fm-profile-content">
                                                   <span class="fm-profilename"><a href="stories-details.html">by Patricia J</a></span>
                                                   </span>
                                                </div>
                                                <ul class="fm-activity fm-rp-info">
                                                   <li><span><img class="fm-svg" src="images/icons/fm-eye.svg" alt="Eye Icon"> 105</span></li>
                                                   <li><span><img class="fm-svg" src="images/icons/fm-heart.svg" alt="Heart Icon"> 80</span></li>
                                                </ul>
                                             </div>
                                             <hr class="my-0" />
                                             <div class="fm-card-btm">
                                                <p class="fm-black-cl fm-icon-content">
                                                   <img src="images/icons/fm-family-group.svg" class="fm-family-icon" alt="Family Icon" /> 
                                                   Johnsons Family
                                                </p>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 <div class="col-md-6 mt-4">
                                    <div class="fm-stories-blog fm-match-height fm-story-select-card active" tabindex="0" role="button" aria-label="Select story: Meeting Your Grandmother">
                                       <div class="fm-stories-cover">
                                          <img class="fm-image" src="images/stories/stories-post-2.png" alt="Review Cover Image">
                                          <span class="fm-tag">2:22</span>
                                          <button class="fm-stories-pp"><img src="images/icons/fm-play.svg" alt="Play Icon" class="fm-svg" /></button>
                                       </div>
                                       <div class="fm-stories-content">
                                          <span class="fm-check-icon">
                                             <img src="images/icons/fm-check.svg" class="fm-svg" alt="Selected" />
                                          </span>
                                          <div class="fm-st-promt-tag">
                                             <span class="fm-st-ti">Love & Relationship</span>
                                             <span class="fm-st-ti fm-light-green"><img src="images/icons/fm-micro-icon.svg" class="fm-svg" alt="Audio Icon"> Audio</span>
                                          </div>
                                          <h4 class="fm-head-20 fm-head-sty2"><a href="stories-details.html">Meeting Your Grandmother</a></h4>
                                          <div class="fm-user-profile">
                                             <div class="fm-userprofile">
                                                <div class="fm-left">
                                                   <div class="fm-userprofile-image">
                                                      <img class="fm-profile" src="images/stories/fm-st-user-01.png" alt="Image">
                                                   </div>
                                                   <span class="fm-profile-content">
                                                   <span class="fm-profilename"><a href="stories-details.html">by Patricia J</a></span>
                                                   </span>
                                                </div>
                                                <ul class="fm-activity fm-rp-info">
                                                   <li><span><img class="fm-svg" src="images/icons/fm-eye.svg" alt="Eye Icon"> 105</span></li>
                                                   <li><span><img class="fm-svg" src="images/icons/fm-heart.svg" alt="Heart Icon"> 80</span></li>
                                                </ul>
                                             </div>
                                             <hr class="my-0" />
                                             <div class="fm-card-btm">
                                                <p class="fm-black-cl fm-icon-content">
                                                   <img src="images/icons/fm-family-group.svg" class="fm-family-icon" alt="Family Icon" /> 
                                                   Johnsons Family
                                                </p>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 <div class="col-md-6 mt-4">
                                    <div class="fm-stories-blog fm-match-height fm-story-select-card active" tabindex="0" role="button" aria-label="Select story: Working at the Factory">
                                       <div class="fm-stories-cover">
                                          <img class="fm-image" src="images/stories/stories-post-3.png" alt="Review Cover Image">
                                          <span class="fm-tag">2:22</span>
                                          <button class="fm-stories-pp"><img src="images/icons/fm-play.svg" alt="Play Icon" class="fm-svg" /></button>
                                       </div>
                                       <div class="fm-stories-content">
                                          <span class="fm-check-icon">
                                             <img src="images/icons/fm-check.svg" class="fm-svg" alt="Selected" />
                                          </span>
                                          <div class="fm-st-promt-tag">
                                             <span class="fm-st-ti">Career & Work</span>
                                             <span class="fm-st-ti fm-light-green"><img src="images/icons/fm-video-icon.svg" class="fm-svg" alt="Video Icon"> Video</span>
                                          </div>
                                          <h4 class="fm-head-20 fm-head-sty2"><a href="stories-details.html">Working at the Factory</a></h4>
                                          <div class="fm-user-profile">
                                             <div class="fm-userprofile">
                                                <div class="fm-left">
                                                   <div class="fm-userprofile-image">
                                                      <img class="fm-profile" src="images/stories/fm-st-user-01.png" alt="Image">
                                                   </div>
                                                   <span class="fm-profile-content">
                                                   <span class="fm-profilename"><a href="stories-details.html">by Patricia J</a></span>
                                                   </span>
                                                </div>
                                                <ul class="fm-activity fm-rp-info">
                                                   <li><span><img class="fm-svg" src="images/icons/fm-eye.svg" alt="Eye Icon"> 105</span></li>
                                                   <li><span><img class="fm-svg" src="images/icons/fm-heart.svg" alt="Heart Icon"> 80</span></li>
                                                </ul>
                                             </div>
                                             <hr class="my-0" />
                                             <div class="fm-card-btm">
                                                <p class="fm-black-cl fm-icon-content">
                                                   <img src="images/icons/fm-family-group.svg" class="fm-family-icon" alt="Family Icon" /> 
                                                   Johnsons Family
                                                </p>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 <div class="col-md-6 mt-4">
                                    <div class="fm-stories-blog fm-match-height fm-story-select-card" tabindex="0" role="button" aria-label="Select story: The War Years">
                                       <div class="fm-stories-cover">
                                          <img class="fm-image" src="images/stories/stories-post-4.png" alt="Review Cover Image">
                                          <span class="fm-tag">2:22</span>
                                          <button class="fm-stories-pp"><img src="images/icons/fm-play.svg" alt="Play Icon" class="fm-svg" /></button>
                                       </div>
                                       <div class="fm-stories-content">
                                          <span class="fm-check-icon">
                                             <img src="images/icons/fm-check.svg" class="fm-svg" alt="Selected" />
                                          </span>
                                          <div class="fm-st-promt-tag">
                                             <span class="fm-st-ti">Major Life Moment</span>
                                             <span class="fm-st-ti fm-light-green"><img src="images/icons/fm-camera.svg" class="fm-svg" alt="Audio and Image Icon"> Audio + Image</span>
                                          </div>
                                          <h4 class="fm-head-20 fm-head-sty2"><a href="stories-details.html">The War Years</a></h4>
                                          <div class="fm-user-profile">
                                             <div class="fm-userprofile">
                                                <div class="fm-left">
                                                   <div class="fm-userprofile-image">
                                                      <img class="fm-profile" src="images/stories/fm-st-user-01.png" alt="Image">
                                                   </div>
                                                   <span class="fm-profile-content">
                                                   <span class="fm-profilename"><a href="stories-details.html">by Patricia J</a></span>
                                                   </span>
                                                </div>
                                                <ul class="fm-activity fm-rp-info">
                                                   <li><span><img class="fm-svg" src="images/icons/fm-eye.svg" alt="Eye Icon"> 105</span></li>
                                                   <li><span><img class="fm-svg" src="images/icons/fm-heart.svg" alt="Heart Icon"> 80</span></li>
                                                </ul>
                                             </div>
                                             <hr class="my-0" />
                                             <div class="fm-card-btm">
                                                <p class="fm-black-cl fm-icon-content">
                                                   <img src="images/icons/fm-family-group.svg" class="fm-family-icon" alt="Family Icon" /> 
                                                   Johnsons Family
                                                </p>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                              <div class="row">
                                 <div class="col-12 mt-4">
                                    <div class="fm-ai-chapter-box">
                                       <h4 class="fm-head-20 fm-title fm-title-dark mb-1">AI Chapter Organization</h4>
                                       <p class="mb-3">Our AI will automatically organize your stories into meaningful chapters and add beautiful formatting</p>
                                       <ul class="fm-ai-chapter-list">
                                          <li><img src="images/icons/fm-check-green.svg" class="fm-svg" alt="Check Icon" /> Chapter 1: Early Years (3 stories)</li>
                                          <li><img src="images/icons/fm-check-green.svg" class="fm-svg" alt="Check Icon" /> Chapter 2: Love & Family (1 story)</li>
                                          <li><img src="images/icons/fm-check-green.svg" class="fm-svg" alt="Check Icon" /> Chapter 3: Life's Work (1 story)</li>
                                       </ul>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="col-lg-4 col-xxl-4">
                     <div class="fm-sidebar-clumn mt-4 mt-lg-0">
                        <div class="fm-border-column fm-book-preview-sidebar">
                           <h3 class="fm-head-20 fm-sidebar-title mb-0">Book Preview</h3>
                           <div class="fm-book-cover-wrap">
                              <img src="images/storybooks/bookcover.png" class="fm-book-cover-image" alt="Book Cover" />
                           </div>
                           <div class="fm-book-stats-box mt-3">
                              <div class="fm-book-stat-item">
                                 <h4 class="fm-head-20">04</h4>
                                 <p class="mb-0">Total Stories</p>
                              </div>
                              <div class="fm-book-stat-item">
                                 <h4 class="fm-head-20">20:10</h4>
                                 <p class="mb-0">Total Duration</p>
                              </div>
                              <div class="fm-book-stat-item">
                                 <h4 class="fm-head-20">28</h4>
                                 <p class="mb-0">Est. Pages</p>
                              </div>
                           </div>
                           <div class="fm-book-includes mt-4">
                              <p>Your Storybook Includes:</p>
                              <div class="fm-book-include-item">
                                 <div class="fm-book-include-icon">
                                    <img src="images/icons/fm-photo.svg" class="fm-svg" alt="Photos Icon" />
                                 </div>
                                 <div>
                                    <p class="fm-include-title mb-0">Photos & Images</p>
                                    <p class="fm-include-text mb-0">Beautiful memories in every page</p>
                                 </div>
                              </div>
                              <div class="fm-book-include-item mt-4">
                                 <div class="fm-book-include-icon">
                                    <img src="images/icons/fm-ai.svg" class="fm-svg" alt="AI Icon" />
                                 </div>
                                 <div>
                                    <p class="fm-include-title mb-0">AI-Formatted Text</p>
                                    <p class="fm-include-text mb-0">Structured stories, beautifully formatted</p>
                                 </div>
                              </div>
                              <div class="fm-book-include-item mt-4">
                                 <div class="fm-book-include-icon">
                                    <img src="images/icons/fm-qr.svg" class="fm-svg" alt="QR Icon" />
                                 </div>
                                 <div>
                                    <p class="fm-include-title mb-0">QR Codes to Videos</p>
                                    <p class="fm-include-text mb-0">Scan to instantly watch your stories anytime</p>
                                 </div>
                              </div>
                           </div>
                           <div class="row g-3 mt-2">
                              <div class="col-12">
                                 <button type="button" class="fm-common-btn fm-sm-btn w-100">Preview Book <img src="images/icons/fm-eye-white.svg" class="fm-svg" alt="Preview Icon" /></button>
                              </div>
                              <div class="col-12">
                                 <button type="button" class="fm-common-btn fm-secondary-btn fm-sm-btn fm-white-btn-txt w-100">Download PDF <img src="images/icons/fm-download-white.svg" class="fm-svg" alt="Download Icon" /></button>
                              </div>
                           </div>
                           <div class="row g-3 mt-2">
                              <div class="col-sm-6 xl-12 col-xxl-6">
                                 <button type="button" class="fm-common-btn fm-border-btn fm-sm-btn w-100">Export DOCX <img src="images/icons/fm-doc.svg" class="d-lg-none d-xxl-inline" alt="Export Icon" /></button>
                              </div>
                              <div class="col-sm-6 xl-12 col-xxl-6">
                                 <button type="button" class="fm-common-btn fm-border-btn fm-sm-btn w-100">Order Print <img src="images/icons/fm-print.svg" class="d-lg-none d-xxl-inline" alt="Print Icon" /></button>
                              </div>
                           </div>
                           <p class="fm-print-note">Print-on-demand service creates professional hardcover books shipped to your door</p>
                        </div>
                     </div>
                  </div>
                  <!-- Create Story Book Section End -->
               </div>
            </div>
            <!-- Content Wrapper End -->
         </div>